<template>
    <AdditionalDescription 
        :entity-type="BUSINESS_TYPE.RESTAURANT"
        :entity-id="+$route.params.id">
        <template v-slot:tabs>
            <RestaurantsTabLinks />
        </template>
    </AdditionalDescription>
</template>

<script>
    import RestaurantsTabLinks from '@/components/RestaurantsTabLinks';
    import AdditionalDescription from '@/components/additional-description/AdditionalDescription';
    import { BUSINESS_TYPE } from '@/utils/order';

    export default {

        name: 'RestaurantAdditionalDescription',

        components: {
            RestaurantsTabLinks,
            AdditionalDescription
        },
  
        data () {
            return {
                BUSINESS_TYPE,
            }
        },
    
        computed: {},

        async mounted() {
        },

        methods: {}
    }
</script>
